var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    rx: 8,
    fill: "#F4B32E",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 27.5H19C18.1716 27.5 17.5 28.1716 17.5 29V32C17.5 32.8284 18.1716 33.5 19 33.5H31C31.8284 33.5 32.5 32.8284 32.5 32V29C32.5 28.1716 31.8284 27.5 31 27.5ZM19 26C17.3431 26 16 27.3431 16 29V32C16 33.6569 17.3431 35 19 35H31C32.6569 35 34 33.6569 34 32V29C34 27.3431 32.6569 26 31 26H19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16.5H19C18.1716 16.5 17.5 17.1716 17.5 18V21C17.5 21.8284 18.1716 22.5 19 22.5H31C31.8284 22.5 32.5 21.8284 32.5 21V18C32.5 17.1716 31.8284 16.5 31 16.5ZM19 15C17.3431 15 16 16.3431 16 18V21C16 22.6569 17.3431 24 19 24H31C32.6569 24 34 22.6569 34 21V18C34 16.3431 32.6569 15 31 15H19Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 30.5C19.75 30.0858 20.0858 29.75 20.5 29.75H26C26.4142 29.75 26.75 30.0858 26.75 30.5C26.75 30.9142 26.4142 31.25 26 31.25H20.5C20.0858 31.25 19.75 30.9142 19.75 30.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 19.5C19.75 19.0858 20.0858 18.75 20.5 18.75H26C26.4142 18.75 26.75 19.0858 26.75 19.5C26.75 19.9142 26.4142 20.25 26 20.25H20.5C20.0858 20.25 19.75 19.9142 19.75 19.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.5C30.5 31.0523 30.0523 31.5 29.5 31.5C28.9477 31.5 28.5 31.0523 28.5 30.5C28.5 29.9477 28.9477 29.5 29.5 29.5C30.0523 29.5 30.5 29.9477 30.5 30.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 19.5C30.5 20.0523 30.0523 20.5 29.5 20.5C28.9477 20.5 28.5 20.0523 28.5 19.5C28.5 18.9477 28.9477 18.5 29.5 18.5C30.0523 18.5 30.5 18.9477 30.5 19.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.8a996ce5c19f2bcd3f05eecd28c3dd4e.svg";
export { ForwardRef as ReactComponent };